import * as React from 'react';
const PortalCompatContext = /*#__PURE__*/React.createContext(undefined);
const portalCompatContextDefaultValue = () => () => undefined;
export const PortalCompatContextProvider = PortalCompatContext.Provider;
export function usePortalCompat() {
  var _React_useContext;
  return (_React_useContext = React.useContext(PortalCompatContext)) !== null && _React_useContext !== void 0 ? _React_useContext : portalCompatContextDefaultValue;
}
//# sourceMappingURL=PortalCompatContext.js.map